<template lang="pug">
div
  div.card(v-if="typeof editable_creative == 'undefined' ")
    div.card-header
      h3.card-title クリエイティブ設定
    div.card-body
      section#creative_wrap(v-if="limit == '' || limit > creatives.length")
        div.form-group(v-if="hide_image == false && iframe_enabled")
          label 表示コンテンツ
          div.form-check
            input#creative_media_type_image.form-check-input(
              type='radio',
              name='creative_media_type',
              value='image',
              :checked="media_type === 'image'",
              @change='setMediaType'
            )
            label.form-check-label(for='creative_media_type_image') 画像
          div.form-check
            input#creative_media_type_iframe.form-check-input(
              type='radio',
              name='creative_media_type',
              value='iframe',
              :checked="media_type === 'iframe'",
              @change='setMediaType'
            )
            label.form-check-label(for='creative_media_type_iframe') iframe
        div.form-group(v-if="hide_image == false && iframe_enabled && media_type == 'iframe'")
          label(for='creative_iframe_embed_url') iframe URL
          input#creative_iframe_embed_url.form-control(
            type='text',
            name='iframe_embed_url',
            placeholder='https://example.com/embed',
            @input='setIframeEmbedUrl',
            @blur='$v.iframe_embed_url && $v.iframe_embed_url.$touch',
            :value='iframe_embed_url'
          )
          template(v-if="$v.iframe_embed_url && $v.iframe_embed_url.$dirty")
            .invalid-feedback(v-if="!$v.iframe_embed_url.required") 入力してください
            .invalid-feedback(v-else-if="!$v.iframe_embed_url.url") URL形式が正しくありません
            .invalid-feedback(v-else-if="!$v.iframe_embed_url.httpsUrl") https のURLを入力してください
            .invalid-feedback(v-else-if="!$v.iframe_embed_url.maxLength") 255文字以内にしてください
          p.text-muted.text-xs.mb-0 固定サイズ（PC: 560x400 / SP: 320x480）
          div.form-check.mt-2
            input#creative_iframe_with_parameters_flag.form-check-input(type='checkbox', name='iframe_with_parameters', @click='setIframeWithParameters', :checked="with_parameters", value=1)
            label.form-check-label(for='creative_iframe_with_parameters_flag') パラメータの引継ぎをする
        label(v-if="show_show_once == true && media_type == 'image'") 画像タイプ
        div.form-group(v-if="hide_image == false && show_show_once == true && media_type == 'image'")
          div.form-group(v-if="hide_image == false")
            label.form-check-label(for='creative_image_is_upload')
              input#creative_image_is_upload.mr-1(type='radio',
                name='is_upload_image',
                :checked="is_upload_image === 1",
                @change='setPreviewListIsUploadImage',
                value="1",
              )
              | アップロード
            label.form-check-label.ml-3(for='creative_image_is_url')
              input#creative_image_is_url.mr-1(type='radio',
                name='is_upload_image',
                :checked="is_upload_image === 0",
                @change='setPreviewListIsUploadImage',
                value="0",
              )
              | URL
          div.form-group(v-if="hide_image == false && is_upload_image == 0")
            label(for='creative_image_url') 画像URL
            input#creative_image_url.form-control(type='text',
            name='image', placeholder='画像のURLを入力',
            @input='setImage',
            @blur='$v.image.$touch',
            :value="image",
            :class="{ 'is-invalid': $v.image.$invalid && $v.image.$dirty, 'is-valid': !$v.image.$invalid && $v.image.$dirty }")
            template(v-if="$v.image.$dirty")
              .invalid-feedback(v-if="is_upload_image == 0 && !$v.image.required") 入力してください
              .invalid-feedback(v-if="!$v.image.url") URL形式が正しくありません
              .invalid-feedback(v-if="!$v.image.maxLength") 255文字以内にしてください
            p.text-muted.text-xs ※SSL化した画像URL（httpではなく、https）をご使用ください。
          div.form-group(v-if="hide_image == false && is_upload_image == 1")
            label(for='creative_image_upload') 画像アップロード
            div
              input#creative_image_upload(type='file',
                accept='.jpg,.jpeg,.gif,.png,.webp',
                ref="fileUpload",
                name='upload_image'
                @change="handleFileChange")
              template(v-if="imageMsg")
                .invalid-feedback {{imageMsg}}
        //- オーバーレイ用
        div.form-check.mb-3(v-if="show_show_once == false")
          div.d-flex
            div.mr-3
              input#creatives_show_sp.form-check-input(type='checkbox', name='show_sp', @change='setShowSp', :checked="show_sp", value=1)
              label.form-check-label(for='creatives_show_sp') スマートフォン
            div.ml-3
              input#creatives_show_pc.form-check-input(type='checkbox', name='show_pc', @change='setShowPc', :checked="show_pc", value=1)
              label.form-check-label(for='creatives_show_pc') PC
          template(v-if="$v.show_sp_or_pc.$dirty")
            .invalid-feedback(v-if="!$v.show_sp_or_pc.required") 選択してください
        div.form-group(v-if="hide_image == false && show_sp == true && show_show_once == false && media_type == 'image'")
          label(v-if="show_sp == true") スマートフォン画像タイプ
          div.form-group(v-if="hide_image == false && show_sp == true")
            label.form-check-label(for='creative_image_is_upload')
              input#creative_image_is_upload.mr-1(type='radio',
                name='is_upload_image',
                :checked="is_upload_image === 1",
                @change='setPreviewListIsUploadImage',
                value="1",
              )
              | アップロード
            label.form-check-label.ml-3(for='creative_image_is_url')
              input#creative_image_is_url.mr-1(type='radio',
                name='is_upload_image',
                :checked="is_upload_image === 0",
                @change='setPreviewListIsUploadImage',
                value="0",
              )
              | URL
          div.form-group(v-if="hide_image == false && is_upload_image == 0")
            label(for='creative_image_url') 画像URL
            input#creative_image_url.form-control(type='text',
            name='image', placeholder='画像のURLを入力',
            @input='setImage',
            @blur='$v.image.$touch',
            :value="image",
            :class="{ 'is-invalid': $v.image.$invalid && $v.image.$dirty, 'is-valid': !$v.image.$invalid && $v.image.$dirty }")
            template(v-if="$v.image.$dirty")
              .invalid-feedback(v-if="is_upload_image == 0 && !$v.image.required") 入力してください
              .invalid-feedback(v-if="!$v.image.url") URL形式が正しくありません
              .invalid-feedback(v-if="!$v.image.maxLength") 255文字以内にしてください
            p.text-muted.text-xs ※SSL化した画像URL（httpではなく、https）をご使用ください。
          div.form-group(v-if="hide_image == false && is_upload_image == 1")
            label(for='creative_image_upload') 画像アップロード
            div
              input#creative_image_upload(type='file',
                accept='.jpg,.jpeg,.gif,.png,.webp',
                ref="fileUpload",
                name='upload_image'
                @change="handleFileChange")
              template(v-if="imageMsg")
                .invalid-feedback {{imageMsg}}
        div.form-group(v-if="hide_image == false && show_pc == true && show_show_once == false && media_type == 'image'")
          label PC用画像タイプ
          div.form-group(v-if="hide_image == false")
            label.form-check-label(for='creative_pc_image_is_is_upload')
              input#creative_pc_image_is_is_upload.mr-1(type='radio',
                name='is_upload_pc_image',
                :checked="is_upload_pc_image === 1",
                @change='setPreviewListIsUploadPcImage',
                value="1",
              )
              | アップロード
            label.form-check-label.ml-3(for='creative_pc_image_is_url')
              input#creative_pc_image_is_url.mr-1(type='radio',
                name='is_upload_pc_image',
                :checked="is_upload_pc_image === 0",
                @change='setPreviewListIsUploadPcImage',
                value="0",
              )
              | URL
          div.form-group(v-if="hide_image == false && is_upload_pc_image == 0")
            label(for='creative_image_url') PC用画像
            input#creative_image_url.form-control(type='text',
            name='image', placeholder='画像のURLを入力',
            accept='.jpg,.jpeg,.gif,.png,.webp',
            @input='setPcImage',
            @blur='$v.pc_image.$touch',
            :value="pc_image",
            :class="{ 'is-invalid': $v.pc_image.$invalid && $v.pc_image.$dirty, 'is-valid': !$v.pc_image.$invalid && $v.pc_image.$dirty }")
            template(v-if="$v.pc_image.$dirty")
              .invalid-feedback(v-if="is_upload_pc_image == 0 && !$v.pc_image.required") 入力してください
              .invalid-feedback(v-if="!$v.pc_image.url") URL形式が正しくありません
              .invalid-feedback(v-if="!$v.pc_image.maxLength") 255文字以内にしてください
            p.text-muted.text-xs ※SSL化した画像URL（httpではなく、https）をご使用ください
          div.form-group(v-if="hide_image == false && is_upload_pc_image == 1")
            label(for='creative_pc_image_upload') 画像アップロード
            div
              input#creative_pc_image_upload(type='file',
                accept='.jpg,.jpeg,.gif,.png,.webp',
                ref="fileUpload",
                name='upload_pc_image'
                @change="handlePcFileChange")
              template(v-if="imageMsg")
                .invalid-feedback {{imageMsg}}
        div.form-group(v-if="show_max_width == true && media_type == 'image'")
          label(for='creative_max_width')
            | PC画像サイズ（横幅）
            help-tooltip(html-key='creativeMaxWidth')
          div
            select.form-control#creative_max_width(
              name='max_width',
              :value="max_width",
              @change='setMaxWidth($event.target.value)'
            )
              option(value='500') 500px（標準）
              option(value='600') 600px
              option(value='700') 700px
              option(value='800') 800px
              option(value='900') 900px
              option(value='1000') 1000px
              option(value='1100') 1100px
              option(value='1200') 1200px（最大）

          p.text-muted.text-xs.mb-0 ※PCの画像は横幅のサイズに合わせて、縦幅は同じ比率で拡大・縮小し表示されます。
          p.text-muted.text-xs ※スマートフォンの画像サイズの指定はできません。（デバイスの横幅に合わせて自動で拡大・縮小し表示されます。）
        div.form-group(v-if="hide_title == false && media_type == 'image'")
          label(for='creative_title') タイトル
          input#creative_title.form-control(type='text',
          name='title',
          placeholder='タイトルを入力',
          @input='setTitle',
          @blur='$v.title.$touch',
          :value="title",
          :class="{ 'is-invalid': $v.title.$invalid && $v.title.$dirty, 'is-valid': !$v.title.$invalid && $v.title.$dirty }")
          template(v-if="$v.title.$dirty")
            .invalid-feedback(v-if="$v.title.required === false") 入力してください
            .invalid-feedback(v-if="$v.title.maxLength === false") 255文字以内にしてください
        div.form-check.mb-3(v-if="hide_arrow_btn == false && media_type == 'image'")
          input#creative_arrow_btn_flag.form-check-input(type='checkbox', name='pr', @change='setArrowBtnFlag', :checked="arrow_btn_flag", value=1)
          label.form-check-label(for='creative_arrow_btn_flag') 右矢印アイコンを表示
        div.form-group(v-if="pop_up_animations != null")
          label(for='creative_pop_up_animation') アニメーション種別
          select.form-control(@change="updatePopUpAnimation", v-model="pop_up_animation")
            option(v-for="(val,key) in pop_up_animations", :value="key") {{val}}
        div.form-group(v-if="pop_up_animations != null && show_countdown")
          countdown(:countdown_types="countdown_types", :show_with_parameters="show_with_parameters")
        div.form-check.mb-3(v-if="show_show_once == true && !show_with_parameters")
          input#creative_powered_by_kenga.form-check-input(type='checkbox', name='pr', @click='poweredByKenga', :checked="powered_by_kenga", value=1)
          div.d-flex.align-items-center
            label.form-check-label(for='creative_powered_by_kenga') 「Powered by SiteLead」の表記を消す
            span.upper-master-label.ml-2 Master以上
            UpgradeUpperMaster(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
        div.form-check(v-if="hide_close_btn == false")
          input#creative_close_btn_flag.form-check-input(type='checkbox', name='pr', @change='setCloseBtnFlag', :checked="close_btn_flag", value=1)
          label.form-check-label(for='creative_close_btn_flag') 削除ボタンを表示
      section#creative_wrap(v-else)
        p widget設定での上限数を超えているので登録できません

  div.card(v-if="typeof editable_creative == 'undefined' && media_type == 'image'")
    div.card-header
      h3.card-title リンク設定
    div.card-body
      section#creative_wrap(v-if="limit == '' || limit > creatives.length")
        div.form-check.mb-3
          input#creatives_target_blank.form-check-input(type='radio', name='select_link_type', @change='setTargetBlank', :checked="target_blank", value=1)
          label.form-check-label(for='creatives_target_blank') リンクあり（別タブ）
          p.text-muted.text-xs ※画像をクリックすると別タブでリンク先URLに遷移します
        div.form-check.mb-3
          input#creatives_inner_link.form-check-input(type='radio', name='select_link_type', @change='setInnerLink', :checked="inner_link", value=1)
          label.form-check-label(for='creatives_inner_link') リンクあり（同じタブ）
          p.text-muted.text-xs.mb-0 ※画像をクリックすると同じタブでリンク先URLに遷移します。
          p.text-muted.text-xs ※クリックの計測はできません。
        div.form-check.mb-3
          input#creatives_no_link.form-check-input(type='radio', name='select_link_type', @change='setNoLink', :checked="no_link", value=1)
          label.form-check-label(for='creatives_no_link') リンクなし
          p.text-muted.text-xs ※画像の表示のみで、画像をクリックしても遷移しません。
          div.form-group(v-if="hide_link == false && no_link == false")
            label(for='creative_link') リンク先URL
            input#creative_link.form-control(type='text',
            name='link',
            placeholder='リンク先のURLを入力',
            @input='setLink',
            :value="link",
            @blur='$v.link.$touch',
            :class="{ 'is-invalid': $v.link.$invalid && $v.link.$dirty, 'is-valid': !$v.link.$invalid && $v.link.$dirty }")
            template(v-if="$v.link.$dirty")
              .invalid-feedback(v-if="!$v.link.required") 入力してください
              .invalid-feedback(v-if="!$v.link.maxLength") 255文字以内にしてください
        div.form-check(v-if="no_link == false && inner_link == false")
          input#creative_with_parameters_flag.form-check-input(type='checkbox', name='with_parameters', @click='setWithParameters', :checked="with_parameters", value=1)
          div.d-flex.align-items-center.mb-3
            label.form-check-label(for='creative_with_parameters_flag')
              | パラメータの引継ぎをする
              help-tooltip(html-key='creativeWithParameters')
            span.upper-master-label.ml-2 Master以上
            UpgradeUpperMaster(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
        div.form-check(v-if="hide_pr == false")
          input#creative_pr.form-check-input(type='checkbox', name='pr', @change='setPrFlag', :checked="pr_flag", value=1)
          label.form-check-label(for='creative_pr') PR を表示
      section#creative_wrap(v-else)
        p widget設定での上限数を超えているので登録できません

  div.card(v-if="typeof editable_creative == 'undefined' && show_show_once == true && !this.is_new_ui")
    div.card-header
      h3.card-title オプション設定
    div.card-body
      section#creative_wrap(v-if="limit == '' || limit > creatives.length")
        div.form-check.mb-3(v-if="show_show_once == true")
          input#creatives_show_once.form-check-input(type='checkbox', name='pr', @change='setShowOnce', :checked="show_once", value=1)
          div.d-flex.align-items-center
            label.form-check-label(for='creatives_show_once') 同一訪問者への表示を1回のみに制限する
            div.position-relative
              img.ml-1(src="/img/question_logo.svg", v-on:mouseover="mouseOverVisitersQuestion" v-on:mouseleave="mouseLeaveVisitersQuestion")
              div.position-absolute.question_popup(v-if="display_visiters_question == true") 同じ訪問者へのポップアップ<br>表示回数を1回に制限できます。<br>訪問者の識別はブラウザ単位です。
        //div.form-group(v-if="pop_up_animations != null && show_time_limit")
        //  time-limit(:time_limit_types="time_limit_types", :show_with_parameters="show_with_parameters")
        div.form-group(v-if="pop_up_animations != null && show_limited_time")
          limited-time-offer
      section#creative_wrap(v-else)
        p widget設定での上限数を超えているので登録できません

  button.btn.btn-primary(type='submit', @click='submit', :class="{ 'disabled': $v.$invalid }")
    span(v-if="id!=''") 更新する
    span(v-else) 登録する
</template>

<script>
import Vue from "vue";

import { required, url, maxLength } from "vuelidate/lib/validators";

//components
import Countdown from "./creative_form/countdown.vue";
import TimeLimit from "./creative_form/time_limit.vue";
import LimitedTimeOffer from "./creative_form/limited_time_offer.vue";
import UpgradeUpperMaster from "./modals/upgrade_upper_master.vue";

export default {
  created() {
    if (this.show_with_parameters) {
      this.$store.commit("creative/setPreviewListPoweredByKenga", true);
    }
  },
  data() {
    return {
      display_parameters_question: false,
      display_visiters_question: false,
      is_upgrade_upper_master_modal: false,
      imageMsg: null,
      validationTriggered: false,
    };
  },
  props: {
    widget_id: { type: String, default: "" },
    pop_up_id: { type: String, default: "" },
    area_pop_up_id: { type: String, default: "" },
    overlay_id: { type: String, default: "" },
    limit: { type: String, default: "10" },
    hide_title: { type: Boolean, default: false },
    hide_image: { type: Boolean, default: false },
    hide_link: { type: Boolean, default: false },
    show_with_parameters: { type: Boolean, default: false },
    hide_pr: { type: Boolean, default: false },
    hide_close_btn: { type: Boolean, default: false },
    hide_arrow_btn: { type: Boolean, default: false },
    after_submit_path: { type: String, default: "" },
    edit_creative: { type: Object, default: null },
    pop_up_animations: { type: Object, default: null },
    show_countdown: { type: Boolean, default: false },
    show_time_limit: { type: Boolean, default: false },
    show_show_once: { type: Boolean, default: false },
    show_no_link: { type: Boolean, default: false },
    show_target_blank: { type: Boolean, default: false },
    sandbox: { type: Boolean, default: false },
    countdown_types: { type: Object, default: null },
    time_limit_types: { type: Object, default: null },
    show_show_pc: { type: Boolean, default: false },
    show_max_width: { type: Boolean, default: false },
    is_new_ui: { type: Boolean, default: false },
    iframe_enabled: { type: Boolean, default: () => !!window.kengaIframeEnabled }
  },
  components: {
    Countdown,
    TimeLimit,
    LimitedTimeOffer,
    UpgradeUpperMaster,
  },
  methods: {
    setTitle(e) {
      this.$store.commit("creative/setPreviewListTitle", e.target.value);
    },
    setImage(e) {
      this.$store.commit("creative/setPreviewListImage", e.target.value);
    },
    setUploadImage(e) {
      this.$store.commit("creative/setPreviewListUploadImage", e.target.files[0]);
    },
    setPreviewListIsUploadImage(e) {
      this.$store.commit("creative/setPreviewListIsUploadImage", Number(e.target.value));
    },
    setPcImage(e) {
      this.$store.commit("creative/setPreviewListPcImage", e.target.value);
    },
    setPreviewListIsUploadPcImage(e) {
      this.$store.commit("creative/setPreviewListIsUploadPcImage", Number(e.target.value));
    },
    setMediaType(e) {
      const mediaType = e.target.value;
      if (mediaType === "iframe" && !this.iframe_enabled) {
        this.$store.commit("creative/setPreviewListMediaType", "image");
        this.$store.commit("creative/setPreviewListIframeEmbedUrl", "");
        return;
      }
      this.$store.commit("creative/setPreviewListMediaType", mediaType);
      if (mediaType === "iframe") {
        this.$store.commit("creative/setPreviewListArrowBtnFlag", false);
        this.$store.commit("creative/setPreviewListNoLink", true);
        this.$store.commit("creative/setPreviewListTargetBlank", false);
        this.$store.commit("creative/setPreviewListInnerLink", false);
        this.$store.commit("creative/setWithParameters", false);
        this.$store.commit("creative/setPreviewListLink", "");
        this.$store.commit("creative/setPreviewListImage", "");
        this.$store.commit("creative/setPreviewListPcImage", "");
        this.$store.commit("creative/setPreviewListUploadImage", "");
        this.$store.commit("creative/setPreviewListUploadPcImage", "");
        this.$store.commit("creative/setPreviewUploadImagePath", "");
        this.$store.commit("creative/setPreviewUploadPcImagePath", "");
      } else {
        this.$store.commit("creative/setPreviewListIframeEmbedUrl", "");
        this.$store.commit("creative/setWithParameters", false);
      }
    },
    setIframeEmbedUrl(e) {
      this.$store.commit("creative/setPreviewListIframeEmbedUrl", e.target.value);
    },
    setIframeWithParameters(e) {
      this.$store.commit("creative/setWithParameters", e.target.checked);
    },
    setLink(e) {
      this.$store.commit("creative/setPreviewListLink", e.target.value);
    },
    setWithParameters(e) {
      if (!this.show_with_parameters) {
        event.preventDefault();
        this.isDisplayModal(e);
      } else {
        this.$store.commit(
          "creative/setWithParameters",
          e.target.checked
        );
      }
    },
    setPrFlag(e) {
      this.$store.commit("creative/setPreviewListPrFlag", e.target.checked);
    },
    setCloseBtnFlag(e) {
      this.$store.commit(
        "creative/setPreviewListCloseBtnFlag",
        e.target.checked
      );
    },
    setArrowBtnFlag(e) {
      this.$store.commit(
        "creative/setPreviewListArrowBtnFlag",
        e.target.checked
      );
    },
    setMaxWidth(val) {
      this.$store.commit("creative/setPreviewListPopUpMaxWidth", val);
    },
    poweredByKenga(e) {
      if (!this.show_with_parameters) {
        event.preventDefault();
        this.isDisplayModal(e);
      } else {
        this.$store.commit(
          "creative/setPreviewListPoweredByKenga",
          e.target.checked
        );
      }
    },
    isDisplayModal(e) {
      this.is_upgrade_upper_master_modal = true;
    },
    mouseOverParametersQuestion() {
      this.display_parameters_question = true;
    },
    mouseLeaveParametersQuestion() {
      this.display_parameters_question = false;
    },
    mouseOverVisitersQuestion() {
      this.display_visiters_question = true;
    },
    mouseLeaveVisitersQuestion() {
      this.display_visiters_question = false;
    },
    updatePopUpAnimation(e) {
      this.$store.commit(
        "creative/setPreviewListPopUpAnimation",
        e.target.value
      );
    },
    setShowOnce(e) {
      this.$store.commit("creative/setPreviewListShowOnce", e.target.checked);
    },
    setShowPc(e) {
      this.triggerValidation();
      this.$store.commit("creative/setPreviewListShowPc", e.target.checked);
    },
    setShowSp(e) {
      this.triggerValidation();
      this.$store.commit("creative/setPreviewListShowSp", e.target.checked);
    },
    setNoLink(e) {
      this.$store.commit("creative/setPreviewListNoLink", e.target.checked);
      // ラジオボタンに変更したため、falseにする処理追加
      this.$store.commit("creative/setPreviewListTargetBlank", false);
      this.$store.commit("creative/setPreviewListInnerLink", false);
    },
    setTargetBlank(e) {
      this.$store.commit("creative/setPreviewListTargetBlank", e.target.checked);
      // ラジオボタンに変更したため、falseにする処理追加
      this.$store.commit("creative/setPreviewListNoLink", false);
      this.$store.commit("creative/setPreviewListInnerLink", false);
    },
    setInnerLink(e) {
      this.$store.commit("creative/setPreviewListInnerLink", e.target.checked);
      // ラジオボタンに変更したため、falseにする処理追加
      this.$store.commit("creative/setPreviewListNoLink", false);
      this.$store.commit("creative/setPreviewListTargetBlank", false);
    },
    handleFileChange(e) {
      // ファイルが選択されたときの処理
      this.imageMsg = ""
      const file = e.target.files[0];
      if (file && file.size > 5 * 1024 * 1024) { // 5MBを超える場合
        this.imageMsg = '5MBを超えるファイルはアップロードできません。'
        this.$refs.fileUpload.value = '';
        this.selectedFile = null;
        return;
      }
      if (file) {
        this.$store.commit("creative/setPreviewListUploadImage", file);
        // FileReader を使用してデータURLに変換
        const reader = new FileReader();
        reader.onload = () => {
          // プレビュー用のデータURLをセット
          this.$store.commit("creative/setPreviewUploadImagePath", reader.result);
        };
        reader.readAsDataURL(file);
        this.$v.$touch();
      }
    },
    handlePcFileChange(e) {
      // ファイルが選択されたときの処理
      this.imageMsg = ""
      const file = e.target.files[0];
      if (file && file.size > 5 * 1024 * 1024) { // 5MBを超える場合
        this.imageMsg = '5MBを超えるファイルはアップロードできません。'
        this.$refs.fileUpload.value = '';
        this.selectedFile = null;
        return;
      }
      if (file) {
        this.$store.commit("creative/setPreviewListUploadPcImage", file);
        // FileReader を使用してデータURLに変換
        const reader = new FileReader();
        reader.onload = () => {
          // プレビュー用のデータURLをセット
          this.$store.commit("creative/setPreviewUploadPcImagePath", reader.result);
        };
        reader.readAsDataURL(file);
        this.$v.$touch();
      }
    },
    async submit() {
      this.$v.$touch();
      console.log(this.$v);
      if (!this.$v.$invalid) {
        if (!this.sandbox) {
          //送信処理
          this.$v.$reset();
          if (this.id != "") {
            const data = await this.$store.dispatch("creative/update");
          } else {
            const data = await this.$store.dispatch("creative/create");
          }
          if (this.after_submit_path != "") {
            location.href = this.after_submit_path;
          } else {
            if (this.id != "") {
              this.$toasted.success("クリエイティブを更新しました");
            } else {
              this.$toasted.success("クリエイティブを登録しました");
            }
            await sleep(10000);
            this.$toasted.clear();
          }
        } else {
          this.$v.$reset();
          this.$toasted.success("demo版なので登録はされません");
          await this.$store.dispatch("creative/create_demo");
        }
      }
    },
    triggerValidation() {
      if (this.validationTriggered) {
        this.$v.show_sp_or_pc.$touch();
      }
    },
  },
  async mounted() {
    await Vue.nextTick();
    if (this.widget_id != "") {
      this.$store.commit("creative/setPreviewListWidgetId", this.widget_id);
    }
    if (this.pop_up_id != "") {
      this.$store.commit("creative/setPreviewListPopUpId", this.pop_up_id);
    }
    if (this.area_pop_up_id != "") {
      this.$store.commit(
        "creative/setPreviewListAreaPopUpId",
        this.area_pop_up_id
      );
    }
    if (this.overlay_id != "") {
      this.$store.commit("creative/setPreviewListOverlayId", this.overlay_id);
    }
    if (this.edit_creative != null) {
      if (typeof this.edit_creative.id !== "undefined") {
        this.$store.commit("creative/setPreviewListId", this.edit_creative.id);
      }
      this.$store.commit(
        "creative/setPreviewListTitle",
        this.edit_creative.title
      );
      this.$store.commit(
        "creative/setPreviewListMediaType",
        this.iframe_enabled && this.edit_creative.iframe_embed_url ? "iframe" : "image"
      );
      this.$store.commit(
        "creative/setPreviewListIframeEmbedUrl",
        this.iframe_enabled ? (this.edit_creative.iframe_embed_url || "") : ""
      );
      this.$store.commit(
        "creative/setPreviewListIframeWidthPc",
        this.iframe_enabled ? (this.edit_creative.iframe_width_pc || 560) : 560
      );
      this.$store.commit(
        "creative/setPreviewListIframeHeightPc",
        this.iframe_enabled ? (this.edit_creative.iframe_height_pc || 400) : 400
      );
      this.$store.commit(
        "creative/setPreviewListIframeWidthSp",
        this.iframe_enabled ? (this.edit_creative.iframe_width_sp || 320) : 320
      );
      this.$store.commit(
        "creative/setPreviewListIframeHeightSp",
        this.iframe_enabled ? (this.edit_creative.iframe_height_sp || 480) : 480
      );
      if (this.iframe_enabled && this.edit_creative.iframe_embed_url) {
        this.$store.commit("creative/setPreviewListNoLink", true);
        this.$store.commit("creative/setPreviewListTargetBlank", false);
        this.$store.commit("creative/setPreviewListInnerLink", false);
        this.$store.commit("creative/setWithParameters", false);
        this.$store.commit("creative/setPreviewListLink", "");
      }
      this.$store.commit(
        "creative/setPreviewListImage",
        this.edit_creative.image
      );
      this.$store.commit(
        "creative/setPreviewListIsUploadImage",
        this.edit_creative.is_upload_image? 1 : 0
      );
      this.$store.commit(
        "creative/setPreviewListPcImage",
        this.edit_creative.pc_image
      );
      this.$store.commit(
        "creative/setPreviewListIsUploadPcImage",
        this.edit_creative.is_upload_pc_image? 1 : 0
      );
      this.$store.commit(
        "creative/setPreviewListLink",
        this.edit_creative.link
      );
      this.$store.commit(
        "creative/setWithParameters",
        this.edit_creative.with_parameters
      );
      this.$store.commit(
        "creative/setPreviewListCloseBtnFlag",
        this.edit_creative.close_btn_flag
      );
      this.$store.commit(
        "creative/setPreviewListArrowBtnFlag",
        this.edit_creative.arrow_btn_flag
      );
      this.$store.commit(
        "creative/setPreviewListPoweredByKenga",
        this.edit_creative.powered_by_kenga
      );
      this.$store.commit(
        "creative/setPreviewListPopUpAnimation",
        this.edit_creative.pop_up_animation
      );
      this.$store.commit(
        "creative/setPreviewListShowOnce",
        this.edit_creative.show_once
      );
      this.$store.commit(
        "creative/setPreviewListShowPc",
        this.edit_creative.show_pc
      );
      if (this.edit_creative.image && !this.edit_creative.show_sp) { // 元々show_spというカラムが存在しなかったので、旧ユーザーに対応させるため
        this.$store.commit("creative/setPreviewListShowSp", 1);
      } else if (this.edit_creative) { // 旧ユーザーが新しくcreativeを作成した場合
        this.$store.commit("creative/setPreviewListShowSp", this.edit_creative.show_sp);
      } else { // creative新規登録の場合
        this.$store.commit("creative/setPreviewListShowSp", 1);
      }
      this.$store.commit(
        "creative/setPreviewListNoLink",
        this.edit_creative.no_link
      );
      this.$store.commit("creative/setCountdown", this.edit_creative.countdown);
      this.$store.commit(
        "creative/setCountBgColor",
        this.edit_creative.countdown_bg_color
      );
      this.$store.commit(
        "creative/setCountFontColor",
        this.edit_creative.countdown_font_color
      );
      this.$store.commit(
        "creative/setCountdownName",
        this.edit_creative.countdown_name
      );
      this.$store.commit(
        "creative/setCountdownType",
        this.edit_creative.countdown_type
      );
      this.$store.commit(
        "creative/setTimeLimitMin",
        this.edit_creative.time_limit_min
      );
      this.$store.commit(
        "creative/setTimeLimitHour",
        this.edit_creative.time_limit_hour
      );
      this.$store.commit(
        "creative/setPrefixCountdownText",
        this.edit_creative.prefix_countdown_text
      );
      this.$store.commit(
        "creative/setTimeLimit",
        this.edit_creative.time_limit
      );
      this.$store.commit(
        "creative/setTimeLimitType",
        this.edit_creative.time_limit_type
      );
      this.$store.commit(
        "creative/setTimeLimitVal",
        this.edit_creative.time_limit_val
      );
      this.$store.commit(
        "creative/setPreviewListTargetBlank",
        this.edit_creative.target_blank
      );
      this.$store.commit(
        "creative/setPreviewListInnerLink",
        this.edit_creative.inner_link
      );
      this.$store.commit(
        "creative/setPreviewListPopUpMaxWidth",
        this.edit_creative.max_width
      );
      this.$store.commit(
        "creative/setTimeLimitSpecificDate",
        this.edit_creative.time_limit_specific_date
      );
    }
    if (this.hide_title) {
      this.$store.commit("creative/setPreviewListTitle", null);
    }
    this.$store.commit("creative/setCountdownUnixTimeLeft");
  },
  watch: {},
  computed: {
    id() {
      return this.$store.state.creative.preview_list.id;
    },
    title() {
      return this.$store.state.creative.preview_list.title;
    },
    image() {
      return this.$store.state.creative.preview_list.image;
    },
    is_upload_image() {
      return this.$store.state.creative.preview_list.is_upload_image;
    },
    upload_image() {
      return this.$store.state.creative.preview_list.upload_image;
    },
    pc_image() {
      return this.$store.state.creative.preview_list.pc_image;
    },
    is_upload_pc_image() {
      return this.$store.state.creative.preview_list.is_upload_pc_image;
    },
    upload_pc_image() {
      return this.$store.state.creative.preview_list.upload_pc_image;
    },
    media_type() {
      return this.$store.state.creative.preview_list.media_type;
    },
    iframe_embed_url() {
      return this.$store.state.creative.preview_list.iframe_embed_url;
    },
    link() {
      return this.$store.state.creative.preview_list.link;
    },
    with_parameters() {
      return this.$store.state.creative.preview_list.with_parameters;
    },
    pr_flag() {
      return this.$store.state.creative.preview_list.pr_flag;
    },
    close_btn_flag() {
      return this.$store.state.creative.preview_list.close_btn_flag;
    },
    arrow_btn_flag() {
      return this.$store.state.creative.preview_list.arrow_btn_flag;
    },
    powered_by_kenga() {
      return this.$store.state.creative.preview_list.powered_by_kenga;
    },
    pop_up_animation() {
      return this.$store.state.creative.preview_list.pop_up_animation;
    },
    editable_creative() {
      return this.$store.getters["creative/findEdit"];
    },
    creatives() {
      return this.$store.state.creative.lists;
    },
    show_once() {
      return this.$store.state.creative.preview_list.show_once;
    },
    show_pc() {
      return this.$store.state.creative.preview_list.show_pc;
    },
    show_sp() {
      return this.$store.state.creative.preview_list.show_sp;
    },
    no_link() {
      return this.$store.state.creative.preview_list.no_link;
    },
    target_blank() {
      return this.$store.state.creative.preview_list.target_blank;
    },
    inner_link() {
      return this.$store.state.creative.preview_list.inner_link;
    },
    max_width() {
      return this.$store.state.creative.preview_list.max_width;
    },
  },
  validations() {
    var obj = {};
    if (this.widget_id != "") {
      obj.title = {
        required,
        maxLength: maxLength(255),
      };
    } else {
      obj.title = {maxLength: maxLength(255)};
    }
    if (this.hide_image == false) {
      if (this.iframe_enabled && this.media_type === "iframe") {
        obj.iframe_embed_url = {
          required,
          url,
          maxLength: maxLength(255),
          httpsUrl: value => !value || /^https:\/\//i.test(value)
        };
      }
      obj.image = {
        url,
        maxLength: maxLength(255),
      };
      obj.pc_image = {
        url,
        maxLength: maxLength(255),
      };
      if (this.media_type !== "iframe" && this.show_show_once) { // pop_up, area_pop_upの時のvalidation
        if (this.is_upload_image == 0) {
          obj.image.required = required;
        }
        if (this.is_upload_image == 1 && this.upload_image == "") {
          obj.upload_image = {required};
        }
      } else if (this.media_type !== "iframe") { // overlayの時のvalidation
        if (this.show_sp) {
          obj.image = {
            url,
            maxLength: maxLength(255),
          };
          if (this.is_upload_image == 0) {
            obj.image.required = required;
          }
          if (this.is_upload_image == 1 && this.upload_image == "") {
            obj.upload_image = {required};
          }
        }
        if (this.show_pc) {
          obj.pc_image = {
            url,
            maxLength: maxLength(255),
          };
          if (this.is_upload_pc_image == 0) {
            obj.pc_image.required = required;
          }
          if (this.is_upload_pc_image == 1 && this.upload_pc_image == "") {
            obj.upload_pc_image = {required};
          }
        }
        obj.show_sp_or_pc = { required: () => this.show_sp || this.show_pc };
      }
    }
    if (this.hide_link == false && this.media_type !== "iframe" && this.no_link == false) {
      obj.link = {
        required,
        maxLength: maxLength(255),
      };
    }
    return obj;
  },
};
</script>
<style lang="scss" scoped></style>
